import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { StarsComponent } from './stars.component';

@NgModule({
  entryComponents: [
    StarsComponent
  ],
  imports: [
    MatIconModule,
    CommonModule
  ],
  declarations: [
    StarsComponent
  ],
  exports: [
    StarsComponent
  ]
})
export class StarsModule { }
